/**
 * Time base for the viewer's decorative motion (chimney smoke, dust in the
 * light shafts).
 *
 * Smoke reads this inside `useFrame` without calling `invalidate()`,
 * so on the demand frameloop they only advance while something else is
 * already repainting (an orbit, a slider drag) and freeze at rest — the
 * same contract as the instanced grass (see
 * 2026-04-11-demand-mode-viewers-must-gate-idle-ambience-loops).
 *
 * Evening shaft dust has its own visibility-gated, 6 fps repaint budget.
 *
 * Under automation the clock is pinned: the visual baselines and the
 * landing-film renderer must get byte-identical frames, and the real clock
 * would put every puff somewhere else on each run. The pinned value is far
 * enough in that the smoke plume has fully formed.
 */
export const AUTOMATED_AMBIENT_TIME_S = 11.5;

export function isAutomatedViewer(): boolean {
	return (
		typeof navigator !== "undefined" &&
		(!!navigator.webdriver || /jsdom/i.test(navigator.userAgent ?? ""))
	);
}

export function resolveAmbientEffectTime(
	elapsedS: number,
	automated: boolean = isAutomatedViewer(),
): number {
	return automated ? AUTOMATED_AMBIENT_TIME_S : elapsedS;
}
